import { type QueryClient } from '@tanstack/react-query';

export const CUSTOMER_DIETARY_RESTRICTIONS_QUERY_KEY = [
  'customer-dietary-restrictions',
];

/**
 * Invalidates all queries related to customer dietary restrictions
 * @param queryClient The react-query client instance
 */
export function invalidateCustomerDietaryRestrictions(
  queryClient: QueryClient
) {
  queryClient.invalidateQueries({
    queryKey: CUSTOMER_DIETARY_RESTRICTIONS_QUERY_KEY,
  });
}
